import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function GuideContents() {
  return <section id="kits" className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-deco-bg scroll-mt-10" data-id="element-85">
      <div className="text-center mb-10 sm:mb-14 max-w-3xl mx-auto" data-id="element-86">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 font-bold leading-tight" data-id="element-87">
          Todo lo que recibís dentro del Kit Flores Eternas Deco
        </h2>
        <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-88">
          Un kit digital completo para aprender, practicar, inspirarte y empezar
          a crear flores eternas desde casa.
        </p>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-[2rem] p-8 sm:p-10 shadow-xl border border-deco-warm flex flex-col md:flex-row gap-8 items-center" data-id="element-90">
          <div className="w-full md:w-1/2 flex flex-col gap-4" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/mk3diWdaxoofhbQg8EY1RP/NUEVO_MOCK_UP_FLORES.png" alt="Flores Eternas Deco - Kit Completo" className="w-full h-auto rounded-xl shadow-sm" data-id="element-92" />
          </div>

          <div className="w-full md:w-1/2 flex flex-col justify-center" data-id="element-93">
            <div className="space-y-4" data-id="element-94">
              {['Guía paso a paso desde cero', '+20 modelos de flores, ramos y creaciones', '+15 videos tutoriales de apoyo', 'Checklist de materiales económicos', 'Ideas para regalar, decorar y vender', 'Recursos para empezar tu emprendimiento creativo', 'Acceso digital de por vida', 'Futuras actualizaciones incluidas si el kit se actualiza'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-95">
                  <span className="text-lg shrink-0 mt-0.5" data-id="element-96">✅</span>
                  <span className="text-deco-text/90 font-medium text-sm sm:text-base" data-id="element-97">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}